import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface FinalStatusButtonProps {
    isAvailable?: boolean;
    to: string;
}

const isButtonAvailable = (isAvailable?: boolean) => {
    return isAvailable;
};

const ContentBtn = styled.button<{ isAvailable?: boolean }>`
  width: 173px;
  height: 60px;
  border: 1.5px solid ${({ isAvailable }) => isAvailable ? '#2282E9' : '#E3E3E3'};
  background-color: white;
  color: ${({ isAvailable }) => isAvailable ? '#2282E9' : '#E3E3E3'};
  border-radius: 5px;
  font-weight: 600;
  cursor: ${({ isAvailable }) => isAvailable ? 'pointer' : 'not-allowed'};
  transition: all 0.2s;

  &:hover {
    background-color: ${({ isAvailable }) => isAvailable ? '#F8F9FA' : 'white'};
  }
`;

export const FinalStatusButton = ({ isAvailable, to }: FinalStatusButtonProps) => {
    return (
      <Link to={isButtonAvailable(isAvailable) ? to : "#"}>
        <ContentBtn 
          isAvailable={isAvailable}
          disabled={!isAvailable}
          onClick={(e) => {
            if (!isAvailable) {
              e.preventDefault();
            }
          }}
        >
          {'확인하기'}
        </ContentBtn>
      </Link>
    );
}; 